import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f7dab66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "datastore-plus-container" }
const _hoisted_2 = { class: "iframe-container" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "loader-div-40 loading-overlay"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "error"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 4,
  class: "no-url"
}

import { ref, onMounted } from "vue";
import { getDataStorePlusUrl } from "@/datastore-plus/services/datastore-plus.service";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import { isDataStorePlusEnabled } from "@/organization/services/organization-datastore-plus.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataStorePlus',
  setup(__props) {

const authenticatedUrl = ref<string | null>(null);
const loading = ref<boolean>(true);
const error = ref<string | null>(null);
const dataStorePlusDisabled = ref<boolean>(false);

function onIframeLoad() {
  // When iframe loads, hide loading indicator
  // Add a small delay to ensure the user sees it loading
  setTimeout(() => {
    loading.value = false;
  }, 300);
}

// Helper function to extract refresh_token from URL
function extractRefreshToken(url: string): string | null {
  try {
    const urlObj = new URL(url);
    const refreshToken = urlObj.searchParams.get("refresh_token");
    return refreshToken;
  } catch (err) {
    console.error("Error parsing URL for refresh_token:", err);
    return null;
  }
}

// Helper function to set cookie for jwt_token format
function setJwtTokenCookie(refreshToken: string): boolean {
  try {
    // For cross-origin scenarios, we'll also attempt to set a less restrictive cookie
    // Note: Setting cookies for external domains is restricted by browser security policies
    // This will only work if the domain matches or if there's appropriate CORS configuration

    // Try setting with secure flag first (more restrictive)
    const encodedToken = encodeURIComponent(refreshToken);
    document.cookie = `jwt_token=${encodedToken}; path=/; SameSite=None; Secure; Domain=.oneteg.com`;
    return document.cookie.includes(`jwt_token=${encodedToken}`);
  } catch (err) {
    console.warn("Failed to set jwt_token cookie:", err);
    // This is expected for cross-origin requests, so we'll just log and continue
    return false;
  }
}

// Helper function to remove token parameter from URL
function removeTokenFromUrl(url: string): string {
  try {
    const urlObj = new URL(url);
    // Remove the token parameter
    urlObj.searchParams.delete("refresh_token");
    return urlObj.toString();
  } catch (err) {
    console.warn("Failed to remove token from URL:", err);
    // Return original URL if parsing fails
    return url;
  }
}

async function checkDataStorePlusEnabled() {
  try {
    const isEnabled = await isDataStorePlusEnabled();
    dataStorePlusDisabled.value = !isEnabled;
  } catch (err) {
    console.error("Error checking data store enabled status:", err);
    dataStorePlusDisabled.value = true;
  }
}

async function fetchAuthenticatedUrl() {
  try {
    // First check if datastore is enabled
    await checkDataStorePlusEnabled();

    // If datastore is disabled, don't proceed with fetching URL
    if (dataStorePlusDisabled.value) {
      loading.value = false;
      return;
    }

    loading.value = true;
    error.value = null;

    const url = await getDataStorePlusUrl();

    if (url) {
      // Extract refresh_token from URL if present
      const refreshToken = extractRefreshToken(url);

      if (refreshToken) {
        // Try setting cookie with multiple approaches for better cross-origin compatibility
        const cookieSet = setJwtTokenCookie(refreshToken);
        // Remove token from URL only if the cookie was actually set
        const finalUrl = cookieSet ? removeTokenFromUrl(url) : url;
        authenticatedUrl.value = `${finalUrl}`;
      } else {
        authenticatedUrl.value = `${url}`;
      }
    } else {
      error.value = "Failed to retrieve Data Store + URL";
      console.log("No DataStore URL returned from service");
    }
  } catch (err) {
    error.value = "Error fetching Data Store + URL";
    console.error("Error fetching DataStore URL:", err);
  } finally {
    // Ensure loading indicator stays visible for a minimum time
    setTimeout(() => {
      loading.value = false;
    }, 1000);
  }
}

onMounted(() => {
  fetchAuthenticatedUrl();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (dataStorePlusDisabled.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("DataStorePlus.DataStorePlusNotAssigned")), 1))
        : (loading.value && !dataStorePlusDisabled.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                alt: "Loading...",
                class: "loader-logo-40"
              }, null, 8, _hoisted_5)
            ]))
          : (error.value && !dataStorePlusDisabled.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
            : (authenticatedUrl.value && !dataStorePlusDisabled.value)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 3,
                  src: authenticatedUrl.value,
                  class: "iframe-container",
                  frameborder: "0",
                  sandbox: "allow-same-origin allow-scripts allow-forms",
                  onLoad: onIframeLoad
                }, null, 40, _hoisted_7))
              : (!dataStorePlusDisabled.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No URL available. Check console for details. "))
                : _createCommentVNode("", true)
    ])
  ]))
}
}

})